import React from 'react';
import c from 'classnames';
import { useDispatch } from 'react-redux';
import { Button, Container, Image, useWindowDimensions, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import ScrollIndicator from '../../../ScrollIndicator';
import { modalOpen } from '../../../../store/actions/Modal';

import './style.scss';

const LARGE_SCREEN_WIDTH = 1240;

const Slide = ({
  title,
  body,
  images,
  externalUrl,
  externalUrlTitle,
  buttonText,
  onNext,
  index,
}) => {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();

  const loadContent = (e) => {
    e.preventDefault();
    dispatch(modalOpen(index));
  };

  const isSingleImage = images && images.size === 1;
  const imageGridClasses = c('Slide__images__grid', {
    'Slide__images__grid--single': isSingleImage,
  });

  const imageStyle = width >= LARGE_SCREEN_WIDTH ? 'annual_overview_8_9' : 'crop_1_1';

  return (
    <div className="Slide">
      <div className="Slide__wrapper">
        <Container>
          <div className="Slide__content">
            <div className="row">
              <div>
                <h1>{title}</h1>
                <WysiwygField
                  property="schema:text"
                  className="ViewIntro__body"
                  html={body}
                />
              </div>
              <div className="Slide__buttons">
                <Button primary={false} className="Button--secondary" onClick={loadContent}>{buttonText || 'Meer info'}</Button>
                {externalUrl && (
                  <Button primary={false} className="Button--secondary" href={externalUrl} target="_blank">{externalUrlTitle} <i className="icon icon-link-outside icon-variant-3" /></Button>
                )}
              </div>
            </div>
            <ScrollIndicator onClick={onNext} />
          </div>
        </Container>
        {images && (
          <div className="Slide__images">
            <div className="row">
              <div className={imageGridClasses}>
                {images.map((image) => {
                  const type = image.get('target_type');
                  const style = image.getIn(['styles', imageStyle]);
                  const key = image.get('target_id');
                  return (
                    <div key={key} className="Slide__images__grid__item">
                      <Image lazyload={false} type={type} src={style} />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Slide;
